import { findByCode } from "../../../helpers";
import { Green } from "../../../styledCpns/DataDisplay";
import { GrayStats, GreenStats, wpSimpleAnTmaker } from "../config";

const OtherPolearms = [
  {
    code: 74,
    name: "Halberd",
    icon: "4/41/Weapon_Halberd",
    rarity: 3,
    mainStatScale: 40,
    subStat: { type: "ATK%", scale: "5.1%" },
    pasvName: "Heavy",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Normal Attacks deal an additional{" "}
            <Green b>{120 + wpRfm * 40}%</Green> <Green>DMG</Green>. Can only
            occur once every 10s.
          </>
        )
      }
    ]
  },
  {
    code: 75,
    name: "White Tassel",
    icon: "1/1f/Weapon_White_Tassel",
    rarity: 3,
    mainStatScale: 39,
    subStat: { type: "CRIT Rate", scale: "5.1%" },
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: wpSimpleAnTmaker("hitBnes", "NA.pct", 6),
        desc: ({ wpRfm }) =>
          findByCode(OtherPolearms, 75).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Sharp",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Increases <Green>Normal Attack DMG</Green> by{" "}
            <Green b>{18 + wpRfm * 6}%</Green>.
          </>
        )
      }
    ]
  },
  {
    code: 76,
    name: "Black Tassel",
    icon: "4/43/Weapon_Black_Tassel",
    rarity: 3,
    mainStatScale: 38,
    subStat: { type: "HP%", scale: "10.2%" },
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: wpSimpleAnTmaker("hitBnes", "All.pct", 10),
        desc: ({ wpRfm }) =>
          findByCode(OtherPolearms, 76).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Bane of the Soft",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Increases <Green>DMG</Green> against slimes by{" "}
            <Green b>{30 + wpRfm * 10}%</Green>.
          </>
        )
      }
    ]
  },
  {
    code: 83,
    name: "Iron Point",
    icon: "2/25/Weapon_Iron_Point",
    ...GreenStats
  },
  {
    code: 84,
    name: "Beginner's Protector",
    icon: "f/fc/Weapon_Beginner%27s_Protector",
    ...GrayStats
  }
];

export default OtherPolearms;
